import { DefaultTheme } from "styled-components";

/** Colors to be used throughout the chat widget.
 * If you want to use other colors, please add them here.
 *
 * A few colors will be overridden based on bot configuration:
 * - `primary` will be overridden by `bot.primaryColor`
 * - `primaryDark` will be overridden by `bot.primaryColor` with a 45% darker shade
 * - `lightPrimary` will be overridden by `bot.primaryColor` with a 45% lighter shade
 */
export const colors = {
  white: "#fff",
  /** Not actually pure black, `"rgba(0, 0, 0, 0.9)"`  */
  black: "rgba(0, 0, 0, 0.9)",
  blue: "#3d82e2",
  grayDark: "#737376",
  grayDarker: "#4a4a4a",
  grayDarkest: "#222",
  grayMed: "#dfdfdf",
  grayLight: "#f4f4f4",
  primary: "#3d82e2",
  /** 45% darker than primary color */
  primaryDark: "#2977d5",
  /** 45% lighter than primary color */
  primaryFaded: "#3d82e273",
  /** 80% lighter than primary color */
  primaryLight: "#3d82e21a",
  /** 90% lighter than primary color */
  primaryLightest: "#3d82e21a",
  warn: "#db1b42",
  warnDark: "#cd0038",
  warnLight: "#f7e7eb",
  /** From TOMIS settings, `botConfig.primaryColor` */
  green: "#6DC41D",
  greenLight: "#E6F4D9",
};

export const shadows = {
  "1": "rgba(0, 0, 0, 0.01)",
  "2": "rgba(0, 0, 0, 0.02)",
  "3": "rgba(0, 0, 0, 0.03)",
  "4": "rgba(0, 0, 0, 0.04)",
  "6": "rgba(0, 0, 0, 0.06)",
  "8": "rgba(0, 0, 0, 0.08)",
  "12": "rgba(0, 0, 0, 0.12)",
  "16": "rgba(0, 0, 0, 0.16)",
  "32": "rgba(0, 0, 0, 0.32)",

  surfaceZ1Light:
    "0px 1px 3px 1px rgba(22, 26, 30, 0.01), 0px 4px 8px -6px rgba(22, 26, 30, 0.08), 0px 1px 5px -4px rgba(22, 26, 30, 0.08), 0px 0px 0px 1px rgba(22, 26, 30, 0.04), 0px 1px 0px 0px rgba(22, 26, 30, 0.02)",
};

export const fontSizes = {
  "1": "13px",
  /** 16px — also the minimum for text inputs; below this iOS Safari zooms focused fields. */
  "2": "16px",
  "3": "18px",
};

export const fontWeights = {
  "1": 400,
  "2": 600,
};

export const fonts = {
  default: '"Open Sans", sans-serif',
};

export const lineHeights = {
  "1": "20px",
  "2": "22px",
  "3": "24px",
};

export const radii = {
  "1": "8px",
  "2": "10px",
  round: "50%",
};

export const sizes = {
  lg: "56px",
  md: "42px",
  sm: "36px",
  xl: "60px",
  xs: "24px",
  xxl: "72px",
  xxs: "16px",
};

export const space = {
  "1": "4px",
  "2": "6px",
  "3": "12px",
  "4": "16px",
  "5": "20px",
  "6": "24px",
};

/** TOMIS default theme, which will be passed to styled-components theme provider */
export const theme: DefaultTheme = {
  colors,
  shadows,
  fontSizes,
  fontWeights,
  fonts,
  lineHeights,
  radii,
  sizes,
  space,
};
